(function(){
  var page=document.querySelector('.sp-page');
  if(!page||page.dataset.spInit)return;
  page.dataset.spInit='1';
  var handle=page.dataset.page||'';
  var body=page.querySelector('[data-sp-body]');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function el(tag,cls,html){var n=document.createElement(tag);if(cls)n.className=cls;if(html!=null)n.innerHTML=html;return n;}
  function slug(s){return s.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,50);}

  /* Group the page content into cards, one per heading. */
  var cards=[];
  if(body){
    var kids=[].slice.call(body.children);
    var frag=document.createDocumentFragment(), current=null;
    kids.forEach(function(node){
      if(node.tagName==='H2'||!current){
        current=el('section','sp-card');
        frag.appendChild(current);
        cards.push(current);
      }
      current.appendChild(node);
    });
    body.innerHTML='';
    body.appendChild(frag);
  }

  /* Reveal cards as they scroll in. */
  if(cards.length){
    if(reduced||!('IntersectionObserver' in window)){
      cards.forEach(function(c){c.classList.add('is-in');});
    }else{
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            var i=cards.indexOf(e.target);
            e.target.style.transitionDelay=(Math.min(i,3)*70)+'ms';
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
      cards.forEach(function(c){io.observe(c);});
      setTimeout(function(){cards.forEach(function(c){
        if(c.getBoundingClientRect().top<window.innerHeight)c.classList.add('is-in');
      });},60);
    }
  }

  /* Wide tables scroll rather than squashing. */
  page.querySelectorAll('.sp-pbody table').forEach(function(t){
    if(t.parentElement.classList.contains('sp-tscroll'))return;
    var w=el('div','sp-tscroll');
    t.parentNode.insertBefore(w,t);
    w.appendChild(t);
  });

  /* Size guide: tap a row to keep it highlighted while you measure. */
  if(handle==='size-guide'){
    page.querySelectorAll('.sp-pbody tbody tr').forEach(function(row){
      row.style.cursor='pointer';
      row.setAttribute('tabindex','0');
      function pick(){
        var on=row.classList.contains('is-pick');
        page.querySelectorAll('.sp-pbody tbody tr').forEach(function(r){r.classList.remove('is-pick');});
        if(!on)row.classList.add('is-pick');
      }
      row.addEventListener('click',pick);
      row.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();pick();}});
    });
  }

  /* FAQs: every question becomes an accordion, with a live filter box. */
  if(handle==='faqs'){
    var questions=[];
    cards.forEach(function(card){
      var nodes=[].slice.call(card.children), open=null;
      nodes.forEach(function(node){
        if(node.tagName==='H3'){
          var q=el('div','sp-q');
          var btn=el('button','sp-q__btn');
          btn.type='button';
          btn.appendChild(el('span',null,node.innerHTML));
          btn.appendChild(el('span','sp-q__ic','<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 4.5L6 8l3.5-3.5"/></svg>'));
          var wrap=el('div','sp-q__wrap');
          var inner=el('div','sp-q__in');
          wrap.appendChild(inner);
          q.appendChild(btn);
          q.appendChild(wrap);
          btn.setAttribute('aria-expanded','false');
          btn.addEventListener('click',function(){
            var openNow=q.classList.toggle('is-open');
            btn.setAttribute('aria-expanded',openNow?'true':'false');
          });
          node.replaceWith(q);
          questions.push(q);
          open={box:inner};
        }else if(open&&node.tagName!=='H2'){
          open.box.appendChild(node);
        }
      });
    });
    if(questions.length){
      var ask=el('div','sp-ask','<svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="9" r="6"/><path d="M13.5 13.5L17 17"/></svg>');
      var input=el('input');
      input.type='search';
      input.placeholder='Search the questions';
      input.setAttribute('aria-label','Search the questions');
      ask.appendChild(input);
      body.parentNode.insertBefore(ask,body);
      var none=el('p','sp-none','No question matches that. Email us and we will answer it.');
      none.hidden=true;
      body.parentNode.insertBefore(none,body.nextSibling);
      input.addEventListener('input',function(){
        var term=input.value.trim().toLowerCase();
        var hits=0;
        questions.forEach(function(q){
          var match=!term||q.textContent.toLowerCase().indexOf(term)>-1;
          q.hidden=!match;
          if(match)hits++;
          if(term&&match)q.classList.add('is-open');
          if(!term)q.classList.remove('is-open');
        });
        cards.forEach(function(card){
          var visible=card.querySelectorAll('.sp-q:not([hidden])').length;
          card.hidden=term&&!visible;
        });
        none.hidden=hits>0;
      });
    }
  }

  /* Long legal pages: contents sidebar, scrollspy and a reading progress bar. */
  var longPage=['terms-conditions','privacy-policy','returns','delivery','your-privacy-choices'].indexOf(handle)>-1;
  var heads=[].slice.call(page.querySelectorAll('.sp-pbody h2'));
  if(longPage&&heads.length>3){
    var split=el('div','sp-split');
    var toc=el('nav','sp-toc','<p>On this page</p>');
    var list=el('ol');
    toc.appendChild(list);
    heads.forEach(function(h,i){
      if(!h.id)h.id='s-'+slug(h.textContent)+'-'+i;
      var li=el('li');
      var a=el('a',null,h.textContent);
      a.href='#'+h.id;
      a.addEventListener('click',function(e){
        e.preventDefault();
        var y=h.getBoundingClientRect().top+window.pageYOffset-70;
        window.scrollTo({top:y,behavior:reduced?'auto':'smooth'});
      });
      li.appendChild(a);
      list.appendChild(li);
    });
    body.parentNode.insertBefore(split,body);
    split.appendChild(toc);
    split.appendChild(body);
    if('IntersectionObserver' in window){
      var links=[].slice.call(list.querySelectorAll('a'));
      var spy=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting)return;
          var i=heads.indexOf(e.target);
          links.forEach(function(a,j){a.classList.toggle('is-here',j===i);});
        });
      },{rootMargin:'-70px 0px -70% 0px'});
      heads.forEach(function(h){spy.observe(h);});
    }
    var prog=page.querySelector('[data-sp-prog] span');
    if(prog){
      var tick=function(){
        var r=body.getBoundingClientRect();
        var total=r.height-window.innerHeight+120;
        var done=Math.min(1,Math.max(0,(120-r.top)/(total>0?total:1)));
        prog.style.width=(done*100).toFixed(1)+'%';
      };
      window.addEventListener('scroll',tick,{passive:true});
      window.addEventListener('resize',tick);
      tick();
    }
  }

  /* Contact: one-tap copy for the email address. */
  if(handle==='contact'||handle==='about'){
    page.querySelectorAll('.sp-pbody p').forEach(function(p){
      var m=p.textContent.match(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/i);
      if(!m||p.querySelector('.sp-copy'))return;
      var addr=m[0];
      var btn=el('button','sp-copy','Copy');
      btn.type='button';
      btn.setAttribute('aria-label','Copy the email address');
      btn.addEventListener('click',function(){
        var done=function(){
          btn.textContent='Copied';
          btn.classList.add('is-done');
          setTimeout(function(){btn.textContent='Copy';btn.classList.remove('is-done');},1800);
        };
        if(navigator.clipboard&&navigator.clipboard.writeText){
          navigator.clipboard.writeText(addr).then(done).catch(function(){});
        }else{
          var t=document.createElement('textarea');
          t.value=addr;document.body.appendChild(t);t.select();
          try{document.execCommand('copy');done();}catch(e){}
          t.remove();
        }
      });
      p.appendChild(btn);
    });
  }

  /* Back to top. */
  var top=el('button','sp-top','<i aria-hidden="true"></i>');
  top.type='button';
  top.setAttribute('aria-label','Back to top');
  document.body.appendChild(top);
  top.addEventListener('click',function(){
    window.scrollTo({top:0,behavior:reduced?'auto':'smooth'});
  });
  window.addEventListener('scroll',function(){
    top.classList.toggle('is-on',window.pageYOffset>520);
  },{passive:true});
})();
